import React from "react";

export const ShowCoversContext = React.createContext<boolean>(true);

export function useShowCovers() {
  return React.useContext(ShowCoversContext);
}
